import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';

import { Unit, UnitsResponse } from '../../interfaces/units.model';

import { environment } from '@unico-people/ongoing-dashboard/enviroment';
import * as fromStore from '@unico-people/shared/dashboard/data-access-store';
import { SessionStorage } from '@unico-people/shared/utils/storage';

@Injectable({ providedIn: 'root' })
export class UnitsService {
  private url: string = environment.url_onboarding;
  acc = SessionStorage.getItem('currentAccount');

  constructor(private http: HttpClient, private store: Store<any>) {
    this.store.pipe(select(fromStore.getOrganizationState)).subscribe(res => {
      this.acc = res?.currentAccount?.uid;
    });
  }

  /**
   * Load all units
   */
  loadAll(acc: string = this.acc): Observable<UnitsResponse> {
    return this.http.get<any>(`${this.url}/units?account=${acc}`);
  }

  /**
   * Load paginated units
   */
  read(): Observable<UnitsResponse> {
    this.acc = SessionStorage.getItem('currentAccount');
    return this.http.get<any>(`${this.url}/units?account=${this.acc}&skip=0&limit=100`);
  }

  /**
   * Load more units
   */
  loadMore(skip: number, limit: number): Observable<UnitsResponse> {
    return this.http.get<any>(`${this.url}/units?account=${this.acc}&skip=${skip}&limit=${limit}`);
  }

  /**
   * Search roles
   * @param query term to search
   */
  search(query: string): Observable<UnitsResponse> {
    return this.http.get<any>(`${this.url}/search/units?account=${this.acc}&q=${query}`);
  }
}
